import { Inject, Injectable } from '@angular/core';
import {
  DOMAIN_INSTANCE_ENDPOINT,
  InstanceManagerService as JppInstanceManagerService
} from "@tylertech/cj-jpp-ui-core";
import { HttpBackend } from "@angular/common/http";
import { OktaAuth } from "@okta/okta-auth-js";
import { OKTA_AUTH } from "@okta/okta-angular";
import { firstValueFrom, Observable, ReplaySubject } from "rxjs";
import { Instance } from "@tylertech/cj-jpp-tims-angular-sdk/model/instance";
import { TimsTokenService } from "./tims-token.service";

@Injectable({
  providedIn: 'root'
})
export class InstanceManagerService extends JppInstanceManagerService {
  private instancesSubject$: ReplaySubject<Instance[]> = new ReplaySubject<Instance[]>(1);

  public override get instanceIdSnapshot(): string {
    return this._timsTokenService.instanceId ?? super.instanceIdSnapshot;
  }

  constructor(httpBackend: HttpBackend,
              @Inject(DOMAIN_INSTANCE_ENDPOINT) domainInstanceEndpoint: string,
              @Inject(OKTA_AUTH)  oktaAuth: OktaAuth,
              @Inject(TimsTokenService) private _timsTokenService: TimsTokenService) {

    super(httpBackend, domainInstanceEndpoint, oktaAuth);
    super.instance$.subscribe(async i => { await this.onInstanceChange(i) });
  }

  public get instances$(): Observable<Instance[]> { return this.instancesSubject$.asObservable() }

  private async onInstanceChange(instance: {instanceId: string, token: string}) {
    try {
      const instances = await firstValueFrom(super.getInstances(500));
      this.instancesSubject$.next(instances.items);
    } catch (err) {
      console.error(err);
      this.instancesSubject$.next([]);
    }
  }
}